import React, { Suspense, useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import PolyBackground from './components/PolyBackground';
import Re from './components/Re';
import {  useSetCurrentUser } from './CurrentUserContext';
import NotFoundPage from './views/404/NotFoundPage';
import Auth from './views/auth/Auth';
import CourseInfo from './views/CourseInfo';
import Courses from './views/Courses';
import Lesson from './views/Lesson';
import './components/Skies.css';
import Mountain from './components/Mountain';


export default function App() {
  
  const [show3D, setShow3D] = useState(()=>false);

  return (
    <>
      <Navbar show3D={show3D} setShow3D={setShow3D}/>
      {/* <PolyBackground /> */}
      {/* <div class="sky-gradient sky-gradient-12"></div> */}
      <Suspense fallback={null}>
        < Mountain show3D={show3D}/>
      </Suspense>
      <div className="main">
        <Routes>
          <Route exact path='/' element={<Courses />}/>
          <Route exact path='/learn/:coursename' element={<CourseInfo />}/>
          <Route exact path='/learn/:coursename/:sectionname/:lessonname' element={<Lesson />}/>
          <Route exact path='/re/:coursename/:sectionname/:lessonname' element={<Re />}/>

          <Route exact path='/auth' element={<Auth/>}/>
          <Route exact path='/register' element={<Auth />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      
    </>
  )
}
